// Keep in sync with riverr-enterprise-integrations
// V2/functions/Shopify/MigrateAllProducts.py
export const THE_HOME_T_UIDS = new Set(["MORzyKSj3bMhbYUtuRIoR88Zv4u1"]);
export const THE_HOME_T_EMAILS = new Set(["ryan2@thehomet.com"]);
export const THE_HOME_T_SHOP_IDS = new Set(["ZM3Uajvg0guqYmgd5MMB11"]);
export const THE_HOME_T_SHOP_URL_MARKER = "the-home-t.myshopify.com";

export const isTheHomeTUser = (user) => {
  if (!user) return false;
  if (THE_HOME_T_UIDS.has(user.uid)) return true;
  const email = String(user.email || "").trim().toLowerCase();
  return THE_HOME_T_EMAILS.has(email);
};

export const isTheHomeTShop = (shop) => {
  if (!shop) return false;
  if (THE_HOME_T_SHOP_IDS.has(shop.id)) return true;
  const url = String(shop.url || shop.shopUrl || "").toLowerCase();
  return url.includes(THE_HOME_T_SHOP_URL_MARKER);
};

export const isTheHomeTListingsActor = ({
  user,
  shops = [],
  sharedBy = "",
} = {}) => {
  if (sharedBy) return THE_HOME_T_UIDS.has(sharedBy);
  if (isTheHomeTUser(user)) return true;
  return (shops || []).some(isTheHomeTShop);
};
